export class ForgotPasswordModel {
    email:string
    constructor() {
        this.email = '';
    }
}